import { formatLicensePlate } from '@anwb/poncho/utilities/license-plate';
import { createSelector } from 'reselect';
import { GearType, GearTypeKey, Store } from 'types';
import { getInteriorColorAndFabric } from 'utils';

import { chosenDurationSelector, chosenKilometrageSelector } from './chosenLeaseCar';
import { isNewCarSelector } from './isNewCar';
import {
	batteryCapacitySelector,
	carBodyAndDoorCountSelector,
	carFuelTypeSelector,
	currentMileageSelector,
	defaultUpgradeSelector,
	fuelConsumptionSelector,
	leaseCarColorsSelector,
	leaseCarDataIdSelector,
	leaseCarDefaultInteriorFabric,
	leaseCarHasDifferentInteriorsSelector,
	leaseCarHasDifferentTransmissionsSelector,
	leaseCarInteriorColorSelector,
	rangeSelector,
	standardMotorSelector,
} from './leaseCarData';

export const leaseCarDataSpecsSelector = createSelector(
	[
		(store: Store) => isNewCarSelector(store),
		(store: Store) => store.leaseCarData?.vehicleData.fuelType,
		defaultUpgradeSelector,
		(store: Store) => carFuelTypeSelector(store),
		(store: Store) => carBodyAndDoorCountSelector(store),
		(store: Store) => standardMotorSelector(store),
		(store: Store) => fuelConsumptionSelector(store),
		(store: Store) => rangeSelector(store),
		(store: Store) => batteryCapacitySelector(store),
		(store: Store) => leaseCarColorsSelector(store),
		(store: Store) => leaseCarDataIdSelector(store),
		(store: Store) => currentMileageSelector(store),
		(store: Store) => leaseCarHasDifferentTransmissionsSelector(store),
		(store: Store) => leaseCarHasDifferentInteriorsSelector(store),
		(store: Store) => leaseCarDefaultInteriorFabric(store),
		(store: Store) => leaseCarInteriorColorSelector(store),
		(store: Store) => chosenDurationSelector(store),
		(store: Store) => chosenKilometrageSelector(store),
	],
	(
		isNewCar,
		fuelType,
		defaultUpgrade,
		carFuelType,
		carBodyAndDoorCount,
		standardMotor,
		fuelConsumption,
		range,
		batteryCapacity,
		leaseCarColors,
		leaseCarDataId,
		currentMileage,
		hasDifferentTransmissions,
		hasDifferentInteriors,
		defaultInteriorFabric,
		interiorColor,
		duration,
		kilometrage
	) => {
		if (!isNewCar) {
			return [
				{
					key: 'Uitvoering',
					value: defaultUpgrade.description || '-',
				},
				{
					key: 'Brandstof',
					value: carFuelType,
				},
				{
					key: 'Transmissie',
					value: GearType[defaultUpgrade.vehicleData?.gearType as GearTypeKey] || '-',
				},
				{
					key: 'Kleur',
					value: leaseCarColors?.[0]?.name || '-',
				},
				{
					key: 'Carrosserie',
					value: carBodyAndDoorCount,
				},
				{
					key: 'Standaardmotor (vermogen in pk)',
					value: standardMotor,
				},
				...(fuelConsumption
					? [
							{
								key: 'Verbruik (fabrieksopgave)',
								value: fuelConsumption,
							},
						]
					: []),
				...(fuelType === 'VE'
					? [
							{
								key: 'Actieradius (fabrieksopgave)',
								value: range,
							},
							{
								key: 'Accucapaciteit',
								value: batteryCapacity,
							},
						]
					: []),
				{
					key: 'Kenteken',
					value: typeof leaseCarDataId === 'string' ? formatLicensePlate(leaseCarDataId) : '-',
				},
				{
					key: 'Kilometerstand',
					value: currentMileage,
				},
			];
		}
		return [
			{
				key: 'Carrosserie',
				value: carBodyAndDoorCount,
			},
			{
				key: 'Standaardmotor (vermogen in pk)',
				value: standardMotor,
			},
			{
				key: 'Brandstof',
				value: carFuelType,
			},
			...(!hasDifferentTransmissions && defaultUpgrade
				? [
						{
							key: 'Transmissie',
							value: GearType[defaultUpgrade.vehicleData.gearType as GearTypeKey] || '-',
						},
					]
				: []),
			...(!hasDifferentInteriors
				? [
						{
							key: 'Bekleding',
							value: getInteriorColorAndFabric(defaultInteriorFabric, interiorColor),
						},
					]
				: []),
			{
				key: 'Looptijd',
				value: `${duration} maanden`,
			},
			{
				key: 'Kilometers per jaar',
				value: `${kilometrage} km`,
			},
		];
	}
);
